import { calcCapacity, calcMonthTerms, formatDate, strToArray } from '../../utils/utils';

const initialState = {
  shortlistedOptions: [],
  shortlistedIds: [],
};

const shortListReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_REQUESTED_TOUR':
      const shortlistedOptions = state.shortlistedOptions.map((item) => {
        if (action.payload.has(item.id)) {
          item.tourRequestedDate = action.payload.get(item.id);
        }

        return item;
      });

      return {
        ...state,
        shortlistedOptions,
      };
    case 'SET_SHORTLIST_DATA':
      const options = action.shortlistedOptions;
      const extractedOptions = [];

      options.map((option) => {
        extractedOptions.push({
          optionId: option.id,
          optionName: option.optionName,
          providerName: option.provider,
          // id: option.ID,
          id: option.id,
          capacity: calcCapacity(option),
          availDate: formatDate(option),
          cost: calcMonthTerms(option),
          images: Array.isArray(option?.images) ? option.images : strToArray(option?.images),
          addressObj: option.address,
          address:
            option.address && option.address.address
              ? option.address.address
              : option.addressBackup,
          amenities: Array.isArray(option?.amenities)
            ? option.amenities
            : strToArray(option?.amenities),
          notes: option.notes,
          providerRequests: option.providerRequests,
          availableSpaceList: option.availableSpaceList,
          ratesToInclude: Array.isArray(option?.ratesToInclude)
            ? option.ratesToInclude
            : strToArray(option?.ratesToInclude),
          coordinates: option.coordinates,
          shortListed: true,
          shortlistedOrder: option.shortlistedOrder,
          avails: option.availableSpaceList,
          queryData: option.queryData,
          queryResponse: option.queryResponse,
          rateVariableTerm: option.rateVariableTerm,
          tourRequestedDate: option.tourRequestedDate,
          tourScheduledDate: option.tourScheduledDate,
          tourScheduledSlot: option.tourScheduledSlot,
          contactName: option.contactName,
          contactNumber: option.contactNumber,
          arrivalDetails: option.arrivalDetails,
          tourCompleted: option.tourCompleted,
          floorPlan: option.floorPlan,
        });
      });

      return {
        ...state,
        shortlistedOptions: extractedOptions,
      };

    case 'SELECT':
      const existingList = state.shortlistedOptions.slice();
      const existingIds = state.shortlistedIds.slice();

      if (state.shortlistedIds.indexOf(action.option.id) < 0) {
        existingList.unshift(action.option);
        existingIds.unshift(action.option.id);
      }

      return {
        shortlistedIds: existingIds,
        shortlistedOptions: existingList,
      };

    case 'DESELECT':
      const optionList = state.shortlistedOptions.slice();
      const reducedList = optionList.filter((option) => option.optionId !== action.id);
      const currentIds = state.shortlistedIds.slice();
      const updatedids = currentIds.filter((id) => id !== action.id);

      return {
        shortlistedIds: updatedids,
        shortlistedOptions: reducedList,
      };

    case 'SET_SHORTLIST_IDS':
      const ids = action.ids;

      return {
        ...state,
        shortlistedIds: ids,
      };

    default:
      return state;
  }
};

export default shortListReducer;
